// extracted by mini-css-extract-plugin
module.exports = {"text":"accordion-text_text__fdFF0"};